import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Card } from '@cortex/web-design-system/components/ui/Card';
import type { CsDailySummary } from '../../types/cs-inquiry.js';
import { TOOLTIP_CONTENT_STYLE, AXIS_TICK_STYLE, GRID_PROPS } from '../../lib/chart-theme.js';

/** @graph-connects none */
export function formatPercent(v: string | number): string {
  return `${Number(v).toFixed(2)}%`;
}

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 問い合わせ発生率推移チャート。日別の新規問い合わせ数÷サブスク会員数を折れ線グラフで表示する。
 * @graph-connects none
 */
export function CsInquiryRateChart({ rows }: { rows: CsDailySummary[] }) {
  const chartData = rows
    .filter(
      (d): d is CsDailySummary & { memberCount: number } =>
        d.memberCount !== null && d.memberCount > 0,
    )
    .map((d) => ({
      label: d.date.slice(5),
      inquiryRate: (d.newChats / d.memberCount) * 100,
    }));

  if (chartData.length === 0) return null;

  return (
    <Card className="p-4">
      <h3 className="mb-1 text-sm font-semibold text-[var(--color-text-primary)]">
        問い合わせ発生率推移
      </h3>
      <p className="mb-3 text-xs text-[var(--color-text-muted)]">
        新規問い合わせ数 ÷ サブスク会員数 × 100
      </p>
      <div style={{ width: '100%', height: 300 }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData} margin={{ top: 4, right: 16, bottom: 4, left: 8 }}>
            <CartesianGrid {...GRID_PROPS} />
            <XAxis dataKey="label" tick={AXIS_TICK_STYLE} tickLine={false} />
            <YAxis
              tick={AXIS_TICK_STYLE}
              tickLine={false}
              axisLine={false}
              tickFormatter={formatPercent}
            />
            <Tooltip contentStyle={TOOLTIP_CONTENT_STYLE} formatter={formatPercent as never} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Line
              type="monotone"
              dataKey="inquiryRate"
              name="発生率"
              stroke="#FE3939"
              dot={false}
              strokeWidth={2}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
